export default __webpack_public_path__ + "static/media/171.0832d3ab.svg";